import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Checkbox } from "../../../components/Checkbox";
import { Message } from "../../../components/Message";

export default class AutoFinishInProduction extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            enabled: false,
        };
    }

    async componentDidMount() {
        const environmentId = await EnvironmentStorage.getSelectedEnvironment();
        const automatic_order_finish = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'automatic_order_finish') || {};

        this.setState({
            enabled: !!automatic_order_finish.enabled,
        })
    }

    async save() {
        const { enabled } = this.state;

        this.setState({ loading: true });
        const environmentId = await EnvironmentStorage.getSelectedEnvironment();
        const automatic_order_finish = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'automatic_order_finish') || {};

        const automaticOrderFinishResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId, 'automatic_order_finish',
            {
                automatic_order_finish: {
                    ...automatic_order_finish,
                    enabled,
                }
            }
        );

        if (automaticOrderFinishResponse.getErrors([]).length > 0) {
            alert({
                text: automaticOrderFinishResponse.getErrors()[0],
                buttonText: "Ok"
            });
            this.setState({ loading: false });
            return false;
        }

        alert({
            text: "Configuração alterada com sucesso",
            buttonText: "Ok"
        });

        this.setState({ loading: false });
        return true;
    }

    render() {
        const { loading, enabled } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer visible={visible} onClose={onClose} closeInFade title="Finalizar pedidos em produção" >
                <div className={styles.secretDrawerContainer}>

                    <Message className="mb-20">
                        <p>
                            Ao ativar essa configuração, todos os pedidos dessa unidade que estiverem <b>Em Produção </b>
                            por mais de 5 horas serão automaticamente finalizados.
                        </p>
                    </Message>

                    <div className={styles.container}>
                        <Checkbox
                            name={`enabled`}
                            design="two"
                            checked={enabled}
                            onChange={(value) => this.setState({ enabled: value })}
                        >
                            Finalizar pedidos em produção
                        </Checkbox>
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.save()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
